// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__7Ny0s","alertIcon":"ConfirmModal_alertIcon__1ZldQ"};